import { access } from '@driftt/traffic-control'

import useCurrentUser from './useCurrentUser'

export default function useIsAdmin(): boolean {
  const isBot = useCurrentUser().bot
  return isBot || access.isAdmin()
}
